// extracted by mini-css-extract-plugin
export default {"formHeading":"fN-z","form":"gN-z","submitBtn":"hN-z","disabled":"iN-z","input":"jN-z","error":"kN-z","submitMsg":"lN-z","signIn":"mN-z"};